<template>
  <form class="pdf-modal pdf-modal_angebot main-form" v-if="mutatedServices">
    <div class="pdf-modal__form">
      <div class="main-form__box main-form__box_relative">
        <label class="main-form__label">Nach dem Kundennamen suchen</label>
        <input
          type="text"
          class="main-form__input"
          v-model="form.search"
          placeholder="Nach dem Kundennamen suchen"
          @input="searchClient"
          @blur="onSearchBlur"
          autocomplete="false"
        />

        <label
          class="user-autocomplete"
          ref="user-autocomplete"
          :style="{
            'z-index': isSearching ? 1 : -1,
          }"
        >
          <div
            class="user-autocomplete__option"
            v-for="item in clients"
            :key="item.id"
            @click="chooseClient(item)"
          >
            <p>{{ item.first_name }} {{ item.last_name }}</p>
          </div>
        </label>
      </div>

      <div class="main-form__box hide-datepicer-icon">
        <div>
          <label class="main-form__label">{{ $t("listsHeader.date") }}</label>
        </div>
        <el-date-picker
          style="width:100%"
          class="multiple-days multiple-days_one"
          v-model="form.should_started_at"
          type="date"
          :placeholder="$t('request.dateHolder')"
          default-time="12:00:00"
          :pickerOptions="pickerOptions"
          ref="datetime-picker-day"
          effect="dark"
        ></el-date-picker>
      </div>

      <div class="main-form__box">
        <label class="main-form__label">{{ $t("navigation.services") }}</label>
        <Select2
          v-validate="'required'"
          data-vv-as="field"
          name="services"
          :options="mutatedServices"
          :settings="selectSettingServices"
          v-model="form.service_id"
          class="select2-container_w100"
          @change="changeService"
        />
      </div>

      <div class="main-form__box">
        <label class="main-form__label">Niederlassung</label>

        <Select2
          v-model="form.office_id"
          :options="filteredList"
          class="select select2-container_w100"
          :settings="selectSetting"
          placeholder="Niederlassung"
          @change="changeOffice"
        />
      </div>

      <div class="main-form__box">
        <label class="main-form__label">Vertragsnummer</label>

        <input
          type="text"
          class="main-form__input"
          v-model="form.contract_number"
          placeholder="Vertragsnummer"
        />
      </div>

      <div class="main-form__box main-form__box_flex">
        <div
          class="main-form__half main-form__half_first-pr12 hide-datepicer-icon"
        >
          <label class="main-form__label">Dauer</label>

          <el-time-select
            class="application-time-picker application-time-picker_w150"
            v-model="duration"
            :picker-options="{
              start: '00:30',
              end: '10:00',
              step: '00:15',
            }"
            placeholder="00:30"
            :editable="false"
            style="width:100%"
          ></el-time-select>
        </div>

        <div class="main-form__half main-form__half_first-pl12">
          <label class="main-form__label"
            >Preis (Leistung * Meistermenge)</label
          >
          <input
            type="text"
            class="main-form__input"
            v-model.lazy="mutatedRecomendedFinalPrice"
            placeholder="Preis"
          />
        </div>
      </div>

      <div
        class="main-form__box main-form__box_relative"
        v-if="mutatedMaterials"
      >
        <label class="main-form__label">Materialien</label>
        <multiselect
          v-model="form.materials"
          :options="mutatedMaterials"
          :multiple="true"
          label="text"
          track-by="id"
          :placeholder="'Materialien'"
        />
      </div>

      <div class="main-form__box" v-if="form.materials.length > 0">
        <div
          class="main-layout__item"
          v-for="(item, index) in form.materials"
          :key="item.id"
        >
          <p class="w-3">{{ index + 1 }}.</p>
          <p class="w-18">{{ item.text }}</p>
          <p class="w-10">€ {{ item.price }}</p>
          <p class="w-20">
            <input
              style="text-align: center;width: 50px;background-color: transparent !important;color: var(--menu-text-color);border: 1px solid var(--border-color);border-radius: 4px;outline:none"
              type="text"
              v-model="item.count"
            />
          </p>
          <p class="w-10">€ {{ item.price * item.count }}</p>
        </div>
      </div>

      <div class="main-form__box main-form__box_flex mt16">
        <button
          class="main-button"
          type="reset"
          @click="generateFile"
          style="border-radius:4px !important"
          :disabled="isSubmitted"
        >
          Generieren
        </button>

        <button
          type="reset"
          class="main-button main-button_w160 ml12"
          style="max-width: 227px;width: 210px !important;border-radius:4px !important"
          @click="generateFileWithEmail"
          :disabled="isSubmitted || !form.contact.email"
        >
          Generieren und an E-Mail senden
        </button>
      </div>
    </div>

    <div class="pdf-modal__content">
      <section class="container-fluid" ref="html">
        <div class="row justify-content-center align-self-center mt-5">
          <div class="col-12">
            <div class="row">
              <div class="col-9 float-left">
                <img
                  v-if="isHilfy"
                  src="https://api.hilfy.at/img/logo-hilfy.png"
                  alt
                  width="184px"
                  height="84px"
                />
                <img
                  v-else
                  src="https://api.hilfy.at/img/logo-profy.png"
                  alt
                  width="184px"
                  height="84px"
                />
              </div>

              <div class="col-3 float-right" v-if="isHilfy">
                <div>Hilfy GmbH</div>
                <div>Ihr Allround-Handwerker</div>
                <div>0800 297921</div>
                <div>info@hilfy.at</div>
              </div>

              <div class="col-3 float-right" v-else>
                <div>Hilfy GmbH</div>
                <div>Kaiserswertherstrasse. 135</div>
                <div>40476 Düsseldorf</div>
                <div>0211-97537177</div>
                <div>Info@hilfy.eu</div>
              </div>
            </div>

            <div class="table-responsive mt-5">
              <table class="table border-0">
                <tr>
                  <td class="border-0 pl-0 pt-1">
                    <b>Leistungen:</b>
                    {{ form.service }}
                  </td>
                </tr>
                <tr>
                  <td class="border-0 pl-0 pt-1">
                    <b>Name:</b>
                    <span>{{ form.contact.name }}</span>
                  </td>
                  <td class="border-0 pl-0 pt-1">
                    <b>Datum.:</b>
                    <span>{{ convertDate(form.should_started_at) }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="border-0 pl-0 pt-1">
                    <b>Adresse:</b>
                    <span>{{ form.contact.address }}</span>
                  </td>
                  <!-- <td class="border-0 pl-0 pt-1">
                    <b>E-mail:</b>
                    <span>{{ form.contact.email }}</span>
                  </td> -->
                </tr>
                <tr>
                  <td class="border-0 pl-0 pt-1" colspan="2">
                    <b>Abweichende Lieferadresse:</b>
                    <span>{{ form.contact.address }}</span>
                  </td>
                </tr>
              </table>
            </div>

            <div class="row mt-5">
              <h2 class="col-12">Angebot {{ form.contract_number }}</h2>
              <div class="col-12">Gerne bieten wir Ihnen an:</div>
            </div>

            <div class="table-responsive mt-5">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th style="border: 1px solid #000000" width="5%">Pos.</th>
                    <th style="border: 1px solid #000000" width="50%">
                      Bezeichnung
                    </th>
                    <th style="border: 1px solid #000000" width="10%">
                      Stunden
                    </th>
                    <th style="border: 1px solid #000000" width="10%">
                      Einheit
                    </th>
                    <th style="border: 1px solid #000000" width="10%">
                      Einzel €
                    </th>
                    <th style="border: 1px solid #000000" width="15%">
                      Gesamt €
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr style="height:40px">
                    <td style="border: 1px solid #000000" width="5%"></td>
                    <td style="border: 1px solid #000000" width="50%">
                      {{ form.service }}
                    </td>
                    <td style="border: 1px solid #000000" width="10%">
                      <span v-if="mutatedRecomendedFinalPrice !== 0">{{
                        form.price.time
                      }}</span>
                    </td>
                    <td style="border: 1px solid #000000" width="10%">
                      <span v-if="mutatedRecomendedFinalPrice !== 0"
                        >Stunde</span
                      >
                    </td>
                    <td style="border: 1px solid #000000" width="10%">
                      <span v-if="mutatedRecomendedFinalPrice != 0"
                        >€
                        {{ getPrice(mutatedRecomendedFinalPrice, true) }}</span
                      >
                    </td>
                    <td style="border: 1px solid #000000" width="15%">
                      <span v-if="mutatedRecomendedFinalPrice != 0"
                        >€
                        {{ getPrice(mutatedRecomendedFinalPrice, true) }}</span
                      >
                    </td>
                  </tr>

                  <tr v-for="(item, index) in form.materials" :key="item.id">
                    <td style="border: 1px solid #000000" width="5%">
                      {{ index + 1 }}
                    </td>
                    <td style="border: 1px solid #000000" width="50%">
                      {{ item.text }}
                    </td>
                    <td style="border: 1px solid #000000" width="10%">
                      {{ item.count }}
                    </td>
                    <td style="border: 1px solid #000000" width="10%">Stuck</td>
                    <td style="border: 1px solid #000000" width="10%">
                      <span>€ {{ getPrice(item.price) }}</span>
                    </td>
                    <td style="border: 1px solid #000000" width="15%">
                      <span>€ {{ getPrice(item.price * item.count) }}</span>
                    </td>
                  </tr>

                  <tr style="height:40px">
                    <td style="border: 1px solid #000000" width="5%"></td>
                    <td style="border: 1px solid #000000" width="50%"></td>
                    <td style="border: 1px solid #000000" width="10%"></td>
                    <td style="border: 1px solid #000000" width="10%"></td>
                    <td style="border: 1px solid #000000" width="10%"></td>
                    <td style="border: 1px solid #000000" width="15%"></td>
                  </tr>
                  <tr style="height:40px">
                    <td style="border: 1px solid #000000" width="5%"></td>
                    <td style="border: 1px solid #000000" width="50%"></td>
                    <td style="border: 1px solid #000000" width="10%"></td>
                    <td style="border: 1px solid #000000" width="10%"></td>
                    <td style="border: 1px solid #000000" width="10%"></td>
                    <td style="border: 1px solid #000000" width="15%"></td>
                  </tr>
                  <tr style="height:40px">
                    <td style="border: 1px solid #000000" width="5%"></td>
                    <td style="border: 1px solid #000000" width="50%"></td>
                    <td style="border: 1px solid #000000" width="10%"></td>
                    <td style="border: 1px solid #000000" width="10%"></td>
                    <td style="border: 1px solid #000000" width="10%"></td>
                    <td style="border: 1px solid #000000" width="15%"></td>
                  </tr>
                  <tr style="height:40px">
                    <td style="border: 1px solid #000000" width="5%"></td>
                    <td style="border: 1px solid #000000" width="50%"></td>
                    <td style="border: 1px solid #000000" width="10%"></td>
                    <td style="border: 1px solid #000000" width="10%"></td>
                    <td style="border: 1px solid #000000" width="10%"></td>
                    <td style="border: 1px solid #000000" width="15%"></td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="table-responsive" style="margin-top:0">
              <table class="table" style="margin-top:0">
                <tbody style="margin-top:0">
                  <tr style="margin-top:0">
                    <td
                      style="border: 1px solid #000000;border-top:unset"
                      width="84.2%"
                    >
                      <div class="mb-1">Zwischensumme (netto)</div>
                      <div class="mb-3">Umsatzsteuer {{ percent }} %</div>
                      <div>Gesamtbetrag</div>
                    </td>
                    <td
                      style="border: 1px solid #000000;border-top:unset"
                      width="14.8%"
                    >
                      <div class="mb-1">
                        <span v-if="mutatedRecomendedFinalPrice !== 0"
                          >€ {{ getSum() }}</span
                        >
                      </div>
                      <div class="mb-3">
                        <span v-if="mutatedRecomendedFinalPrice !== 0"
                          >€ {{ getVat() }}</span
                        >
                      </div>
                      <div>
                        <span v-if="mutatedRecomendedFinalPrice !== 0"
                          >€ {{ getWholePrice() }}</span
                        >
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="row mt-3">
              <div class="col-12">
                Zahlbar rein netto innerhalb von 10 Tagen
              </div>
              <div class="col-12">
                Wir freuen uns auf Ihre Auftragserteilung und sichern eine
                einwandfreie Ausführung zu.
              </div>
            </div>

            <div class="row mt-5" v-if="isHilfy">
              <div class="col" style="line-height: 1rem">
                <span class="small">
                  Es gelten unsere AGB-siehe, www.hilfy.at, 1010 Wien,
                  Rosenbursenstraße 2/21
                  <br />Die eingetragenen Daten sind vom Besteller oder seinem
                  Beauftragten zu prüfen und die Richtigkeit der Eintragungen
                  durch Unterschrift zu bestätigen. <br />Eventuelle
                  Abweichungen sind sofort auf dem Arbeitsschein zu vermerken.
                  <br />Arbeitsscheine dienen als Berechnungsgrundlage.
                  Gerichtsstand Wien. UID-Nr.: ATU 75207223; FB Nr.: FN 488463 d
                  <br />Raiffeisenlandesbank Wien, IBAN: AT59 3200 0000 1308
                  2672; BIC: RLNWATWW.
                </span>
              </div>
            </div>

            <div class="row mt-5" v-else>
              <div class="col" style="line-height: 1rem">
                <span class="small">
                  Es gelten unsere AGB-siehe, "getprofy.de"
                  <br />Die eingetragenen Daten sind von Besteller oder seinem
                  Beauftragten zu prüfen und die Richtigkeit der Eintragungen
                  durch Unterschrift zu bestätigen. <br />Eventuelle
                  Abweichungen sind sofort auf dem Arbeitsschein zu vermerken.
                  <br />Arbeitsscheine dienen als Berechnungsgrundlage,
                  Gerichtstand Düsseldorf, USt - IdNr: (VAT) DE333291445;
                  <br />HR Nr.: HRB 90459 solarisBank AG, IBAN: DE31 1101 0100
                  2848 6852 17; BIC: SOBKDEBBXXX
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </form>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import date from '@/mixins/date'
import utf8_to_b64 from '@/utils/utf8_to_b64'
import recomendedPrice from '@/mixins/recomendedPrice'
// import moment from "moment";

const rounded = (number) => Math.ceil(number * 100) / 100

const formatPrice = (price) => (Number.isInteger(price) ? `${price}.00` : price)

export default {
    name: 'actAcceptance',
    mixins: [date, recomendedPrice],
    data() {
        return {
            selectSettingServices: {
                placeholder: this.$t('navigation.services'),
                allowClear: false,
            },
            selectSetting: {
                placeholder: 'Office',
            },
            mutatedServices: null,
            duration: '01:00',
            service: {},
            mutatedMaterials: null,
            isSearching: false,
            isSubmitted: false,
        }
    },
    computed: {
        ...mapGetters({
            clients: 'clientsData',
            services: 'servicesFullData',
            form: 'pdf/pdf',
            materials: 'materials/getMaterials',
            filteredList: 'offices/filteredList',
        }),
        isHilfy() {
            return this.$config.behavior === 'hilfy'
        },
        mutatedRecomendedFinalPrice: {
            get() {
                return this.recomendedFinalPrice
            },
            set(v) {
                this.setPriceByKey('_15', 0)
                this.setPriceByKey('hours', parseFloat(!!v === false ? 1 : v))
                this.setPriceByKey('recomended', 1)
                this.setPriceByKey(
                    'executorsQuantity',
                    this.form.executors.length || 1,
                )
            },
        },
        finalPrice() {
            const sum = this.form.materials.reduce(
                (accum, item) => (item.price * item.count),
                0,
            )
            return this.mutatedRecomendedFinalPrice + sum
        },
        percent() {
            return this.isHilfy ? 20 : 19
        },
    },
    watch: {
        duration(value) {
            const priceFifteen = this.service.price_fifteen

            const hours = Number(value.split(':')[0]) * 60
            const minutes = Number(value.split(':')[1])
            const sum = hours + minutes

            const result = ((sum - 60) / 15) * priceFifteen
            this.form.price.time = value
            this.setPriceByKey('_15', result)
            this.setPriceByKey('executorsQuantity', this.form.executors.length || 1)
        },
    },
    methods: {
        ...mapActions({
            getClientsData: 'getClientsData',
            generate: 'pdf/generate',
            fetchMaterials: 'materials/fetch',
            sendEmail: 'pdf/sendEmail',
        }),
        ...mapMutations({
            clearMaterials: 'materials/clear',
        }),
        pressButton() {
            this.isSubmitted = true
        },
        addRow() {
            this.form.columns += 1
        },
        onSearchBlur() {
            if (this.form.search) return
            this.isSearching = false
        },
        searchClient() {
            this.getClientsData({ word: this.form.search })
            this.isSearching = true
        },
        chooseClient(client) {
            this.form.contact.name = `${client.first_name} ${client.last_name}`
            this.form.contact.email = client.email
            this.form.contact.phone = client.phone
            this.form.contact.id = client.id
            this.form.search = this.form.contact.name
            this.form.contact.first_name = client.first_name
            this.form.contact.last_name = client.last_name

            if (client.addresses[0]) {
                this.form.contact.address = `${client.addresses[0].street}, ${client.addresses[0].house}, ${client.addresses[0].apartment}, ${client.addresses[0].country}, ${client.addresses[0].city}`
                // eslint-disable-next-line prefer-destructuring
                this.form.address = client.addresses[0]
            }
            if (client.office) {
                this.form.office_id = client.office.id
            }

            this.isSearching = false
        },
        changeOffice() {
            // const service = this.mutatedServices.find(
            //     (item) => item.id === this.form.service_id,
            // )

            const office = this.service.office_prices.find(
                (item) => item.id === this.form.office_id,
            )

            this.setOffice(office)
        },
        setOffice(officeAttr) {
            let office = {}
            if (!officeAttr) {
                office = {
                    prices: {
                        price: 0,
                        price_fifteen: 0,
                    },
                }
            }

            this.service = { ...this.service, ...office.prices }
            this.setPriceByKey('hours', office.prices.price)
            this.setPriceByKey(
                '_15',
                this.getPriceFromDuration({
                    price_fifteen: office.prices.price_fifteen,
                    price: office.prices.price,
                }),
            )
            this.setPriceByKey('executorsQuantity', this.form.executors.length || 1)
        },
        getSum() {
            const servicePrice = this.getPrice(
                this.mutatedRecomendedFinalPrice,
                true,
            )
            let materialsPrice = 0

            this.form.materials.forEach((material) => {
                materialsPrice = parseFloat(materialsPrice)
          + parseFloat(this.getPrice(+material.count * +material.price))
            })
            return formatPrice(rounded(+servicePrice + +materialsPrice))
        },
        getWholePrice() {
            return formatPrice(rounded(+this.getSum() + +this.getVat()))
        },
        getVat() {
            return formatPrice(rounded(this.getSum() * (this.percent / 100)))
        },
        getPrice(price) {
            const vat = rounded((price * this.percent) / 120)

            return formatPrice(
                this.isHilfy ? rounded(price - vat) : rounded(price - vat),
            )
        },
        changeMaterialCount(id, event) {
            const count = +event.target.textContent

            this.form.materials = this.form.materials.map((material) => {
                if (material.id === id) {
                    material.count = count
                    return material
                } else return material
            })
        },
        getPriceFromDuration(data) {
            const priceFifteen = data.price_fifteen
            const value = this.duration || '01:00'
            const hours = Number(value.split(':')[0]) * 60
            const minutes = Number(value.split(':')[1])
            const sum = hours + minutes
            return ((sum - 60) / 15) * priceFifteen
        },
        changeService() {
            this.service = this.services.find(
                (item) => item.id === this.form.service_id,
            )

            this.form.service = this.service.title
            this.getMaterials()

            if (this.form.office_id) {
                const office = this.service.office_prices.find(
                    (item) => item.id === this.form.office_id,
                )
                // const prices =
                //   office == undefined
                //     ? {
                //         price: 0,
                //         price_fifteen: 0,
                //       }
                //     : office.prices;

                this.setOffice(office)
            } else {
                this.setOffice(this.service.office_prices[0])
            }
        },
        getHtml() {
            const html = this.$refs.html.innerHTML
            return utf8_to_b64(html)
        },
        getClient() {
            return this.form.contact.name !== '' ? this.form.contact : null
        },
        prepareForm() {
            return {
                type: 'commercial-offer',
                total: `${this.getWholePrice()}`,
                client: this.getClient(),
                data: {
                    type: 'commercial-offer',
                    ...this.form,
                    total: `${this.getWholePrice()}`,
                    totalNoVat: this.mutatedRecomendedFinalPrice,
                    date: this.convertDate(this.form.should_started_at),
                },
                html: this.getHtml(),
            }
        },
        notify() {
            this.$notify({
                title: 'PDF generiert',
                message: 'Sie haben erfolgreich eine PDF-Datei generiert',
                duration: 5000,
            })
        },
        async generateFile() {
            this.pressButton()
            const form = this.prepareForm()
            const response = await this.generate(form)
            const isOkey = response.status === 201

            if (!isOkey) return

            this.notify()
            this.$emit('done')
        },
        async generateFileWithEmail() {
            this.pressButton()
            const form = this.prepareForm()
            const response = await this.generate(form)
            const isOkey = response.status === 201

            if (!isOkey) return

            this.notify()
            this.$emit('done')

            await this.sendEmail({
                id: response.data.id,
                email: form.data.contact.email,
            })
        },
        getMaterials() {
            this.clearMaterials()
            this.fetchMaterials({ id: this.service.id, page: 'materials' }).then(
                () => {
                    this.mutatedMaterials = this.materials.map((material) => ({
                        price: material.price,
                        text: material.name.original,
                        count: 1,
                        id: material.id,
                    }))
                },
            )
        },
    },
    async beforeMount() {
        if (!this.services[0]) return

        this.mutatedServices = this.services.map((service) => ({
            id: service.id,
            text: service.title,
        }))

        this.service = this.form.service_id
            ? this.services.find((item) => item.id === this.form.service_id)
            : this.services[0]

        const office = this.service.office_prices.find(
            (item) => item.id === this.form.office_id,
        )
        this.setOffice(office)
        // this.form.service_id = this.service.id;
        this.getMaterials()

        this.duration = this.form.price.time
    },
}
</script>

<style lang="scss" scoped>
@import "src/assets/sass/_bootstrap.min.scss";

.pdf-modal .row {
  border-bottom: unset !important;
  height: unset !important;
}

.pdf-modal {
  line-height: 1.5 !important;
}

@media print {
  .new-page {
    page-break-before: always !important;
  }
}

ul {
  list-style-type: circle !important;
}
</style>
